import { z } from 'zod';

/**
 * A backend vocabulary, following the tolerance policy written in
 * `src/lib/investor-analytics/schemas.ts`: a bounded string, never a closed
 * enum, so one value this build has not seen cannot reject a healthy 200
 * and take the screen down with it. The known values stay in the type so
 * consumers keep their narrowing, and every consumer owes the reader a
 * display fallback for the rest. Shared by the investor contracts and the
 * vault record.
 *
 * A value is trimmed and must say something: a blank or whitespace value is
 * not a new word, it is a blank label downstream. It fails the field. A
 * field that already has an absent state (null, or its own "unknown") takes
 * that state through `.catch`; a required field with none stays invalid,
 * like any other malformed required field.
 */
export function vocabulary<const Known extends string>(
  _known: readonly Known[]
) {
  return z.string().trim().min(1).max(64) as unknown as z.ZodType<
    Known | (string & {})
  >;
}
